import { cn } from '@zoomit/primitives';
import { isMobile } from '@zoomit/web-kit';

import type { MenuParserData } from '../../../types/menus';
import DefaultMenuDesktop from './DefaultMenuDesktop';
import DefaultMenuMobile from './DefaultMenuMobile';

const DefaultMenu = (props: MenuParserData) => {
  return isMobile ? (
    <DefaultMenuMobile {...props} />
  ) : (
    <>
      <div
        className={cn(
          'sticky top-0 z-50 hidden h-16 w-full lg:block',
          props.variant === 'transparent' && '-mb-16',
        )}
      >
        <DefaultMenuDesktop {...props} />
      </div>
      <DefaultMenuMobile {...props} />
    </>
  );
};

export default DefaultMenu;
